import { Component, inject, Input, OnInit, input, ChangeDetectionStrategy } from '@angular/core';
import { jkLib } from '../../services/jkCommon';
import { webSpeechClass } from '../../services/jkWebSpeech';
import { delay } from 'rxjs/operators';
import mqtt, { MqttClient } from 'mqtt';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { AudioService } from '../../services/audio';
import { AzureTtsService } from '../../services/jkAzure';
import { JkcheckboxComponent } from '../jkcheckbox/jkcheckbox.component';
import { JknumbereditComponent } from '../number-edit/number-edit.component';
import { JktextareaComponent } from '../jktextarea/jktextarea.component';
import { AzureEnvironment } from '../../services/jkInterface';

@Component({
  selector: 'app-mqtt-speaker',
  standalone: true,
  imports: [JkcheckboxComponent,JknumbereditComponent,JktextareaComponent],
  templateUrl: './mqtt-speaker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mqtt-speaker.component.css'
})
export class MqttSpeakerComponent  extends JkBaseComponent implements OnInit {
  protected tts = inject(AzureTtsService);

  override comType: string = 'mqtt-speaker';
  readonly azureEnv = input.required<AzureEnvironment>();
  mp3_pristine: string = '/assets/audio/'+'pristine.mp3';

  //tts: AzureTtsService = new AzureTtsService(orm.http);
  isMqttConnected: boolean = false;
  mqttClient!: MqttClient;
  notifyTopic: string = 'textToSpeaker/jk2022';
  webSpeech!: webSpeechClass;
  _pubSecond: number = 20000;
  get pubSecond(): number {
    return this._pubSecond;
  }
  set pubSecond(value: number) {
    this._pubSecond = value;
  }
  //voiceIndex: number = 21;
  message: string = '無message資料';
  logMessage: string = '無logMessage資料';
  isAzureSpeech: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  isSilence: boolean = false;
  init(mqttOptions:any){
    this.mqttClient = mqtt.connect(mqttOptions['default']); // jack168Ws jack168Mqtt
    this.mqttClient.options.keepalive = 600;
    this.webSpeech = new webSpeechClass(this.cdr);
  }
  override ngOnInit(): void {
    super.ngOnInit();
    this.webSpeech.init();
  }
  override async ngAfterViewInit():Promise<void> {
    super.ngAfterViewInit();
    this.processMqtt(this.notifyTopic);

    this.webSpeech.language2VoiceIndex('zh-TW');// prompt("Please enter a string:");
  }
  myMessage(msg: string) {
    this.message = msg;
    this.logMessage = jkLib.nowTime8() + ' ' + msg + '\n' + this.logMessage;
    //this.logMessage = '<div>'+jkLib.nowTime8() + '</div> ' + msg + '<br>' + this.logMessage;
    this.cdr.markForCheck();
  }
  async myBeep(count: number) {
    for (let i = 0; i < count; i++) {
      const audio = new AudioService();
      audio.play(this.mp3_pristine);
    }
  }

  async myWebSpeech(isMusic: boolean, message: string) {
    if (!message) return;
    if (message === '') return;
    if (this.isSilence) return;
    if (isMusic) {
      await this.myBeep(1);
      await delay(1000);
    }
    this.tts.speakText(this.azureEnv(),message);
    this.myMessage(message);
  }
  doStopSpeech() {
    this.webSpeech.stop();
  }
  processMqtt(topic: string) {
    try {
      this.mqttClient.on('connect', () => {
        this.mqttClient.options.keepalive = 60;

        if (!this.isMqttConnected) {
          //this.mqttClient.publish(topic, '', { retain: false }); // 清除舊訊息
          let startMsg = this.orm.ip()   + 'mqttSpeaker topic:' + topic + '  上線!';//jkGlb.ip
          this.mqttClient.publish(topic, startMsg);
          /*interval(this.pubSecond).subscribe(() => {
            this.mqttClient.publish('keepAlive', jkLib.nowTime12()+' mqttSpeaker:' + jkGlb.ip);
          });
          */
        }
        if (!this.isMqttConnected) {
          this.mqttClient.subscribe(topic, (err) => {
            this.isMqttConnected = true;
            this.myMessage('訂閱成功:' + topic);
            if (err) {
              let msg = 'mqttSpeaker mqtt subscribe error:' + err.message;
              //console.error(msg);
              this.myMessage(msg);
            } else {
              this.isMqttConnected = true;
              let msg = 'mqttSpeaker mqtt subscribe success:' + topic+ ' '+
              this.orm.ip();
              this.myMessage(msg);
            } // if (err)
          });
        } // if (!this.isMqttConnected)
      }); // on connect
      this.mqttClient.on(
        'message',
        (topic: string, payload: Buffer, packet: any) => {
          let msg = payload.toString();
          //this.myMessage(msg);
          try {
            this.doSpeaker(topic, msg);
            // jkMqtt.mqttClient.end(); callback 這不是在jkMqttClass 內
          } catch (error: any) {
            let msg = 'mqttSpeaker onMessage error:' + error.message;
            this.myMessage(msg);
          }
        }
      );
      this.mqttClient.on('disconnect', (packet) => {
        this.myMessage('mqtt mqttSpeaker disconnect');
      });
      this.mqttClient.on('error', (error) => {
        this.myMessage('XXX mqtt mqttSpeaker error:' + error.message);
      });
      this.mqttClient.on('close', () => {
        // this.myMessage('mqttSpeaker close'); 3秒發生一次
      });
      this.mqttClient.on('offline', () => {
        // this.myMessage('mqtt mqttSpeaker offline  '); // 3秒發生一次
      }); // this.onOffline
    } catch (error: any) {
      this.myMessage('mqtt mqttSpeaker create error:' + error.message);
    }
  }
  async doSpeaker(topic: string, msg: string) {
    try {
        this.myWebSpeech(true, msg);
    } catch (error: any) {
      console.error('mqttSpeaker doSpeaker error:' + error.message);
    }
  }
}
